import React from "react";
import dayjs from "dayjs";
import Image from "components/image-containers/Image/Image.component";

// import MailingListForm from 'app/main/components/MailingListForm/MailingListForm.component';

// Material UI Components
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

// Icons
import YouTubeIcon from "@mui/icons-material/YouTube";
import TikTokIcon from "components/icons/TikTikIcon/TikTokIcon.component";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// Helpers
import {
  articlesRoute,
  homeRoute,
  paymentCalculatorRoute,
  privacyRoute,
  tosRoute,
  vinnYouTubeRoute,
  vinnTiktokRoute,
  vinnInstagramRoute,
  vinnFacebookRoute,
  vinnPinterestRoute,
  vinnLinkedInRoute,
} from "routes";
import { vinnLogoInverse } from "assets/externalImages";
import CustomNextLink from "components/links/CustomNextLink/CustomNextLink.component";

const YEAR = dayjs().format("YYYY");

const Footer = () => {
  const socialMediaLinks = [
    { icon: YouTubeIcon, href: vinnYouTubeRoute },
    { icon: TikTokIcon, href: vinnTiktokRoute },
    { icon: InstagramIcon, href: vinnInstagramRoute },
    { icon: FacebookIcon, href: vinnFacebookRoute },
    { icon: PinterestIcon, href: vinnPinterestRoute },
    { icon: LinkedInIcon, href: vinnLinkedInRoute },
  ];
  const resourceLinkStyles = {
    fontSize: "14px",
    fontWeight: 300,
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingRight: "8px",
  };

  return (
    <Box
      sx={{
        backgroundColor: "dark.main",
        color: "white",
        padding: {
          xs: "80px 16px",
          md: "80px 20px",
        },
      }}
    >
      <Box
        sx={{
          paddingBottom: "48px",
        }}
        data-cy="vinn-footer"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              md: "row",
            },
            justifyContent: "space-between",
            gap: "16px",
          }}
        >
          <Box>
            <Box
              sx={{
                paddingBottom: "48px",
              }}
            >
              <CustomNextLink
                href={homeRoute}
                aria-label="Navigate to Vinn homepage"
              >
                <Image
                  width={120}
                  height={46}
                  src={vinnLogoInverse}
                  alt="vinn logo"
                />
              </CustomNextLink>
            </Box>
            <Typography
              sx={{ padding: "10px 0", fontWeight: 500 }}
              variant="h3"
            >
              Follow us
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "24px",
              }}
            >
              {socialMediaLinks.map((link) => (
                <CustomNextLink key={link.href} href={link.href}>
                  <link.icon />
                </CustomNextLink>
              ))}
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{ padding: "10px 0", fontWeight: 500 }}
              variant="h3"
            >
              Resources
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CustomNextLink
                color="rgba(245, 245, 245, 0.4)"
                style={resourceLinkStyles}
                href={articlesRoute}
              >
                Reviews and articles
              </CustomNextLink>
              <CustomNextLink
                color="rgba(245, 245, 245, 0.4)"
                style={resourceLinkStyles}
                href={paymentCalculatorRoute}
              >
                Payment calculator
              </CustomNextLink>
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider
        sx={{
          borderColor: "#4d4d4d",
          margin: "32px 0px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          gap: "8px",
          color: "rgba(255,255,255, 0.8)",
          fontWeight: "300",
          paddingBottom: "32px",
        }}
      >
        <Typography
          sx={{ maxWidth: { xs: "100%", md: "50%" }, fontWeight: "300" }}
        >
          Copyright © {YEAR} VINN Automotive Technologies Ltd. All Rights
          Reserved. All other trademarks are the property of their respective
          owners.
        </Typography>
        <Box
          sx={{
            padding: "8px",
            display: "flex",
            alignItems: "center",
            alignContent: "flex-start",
            justifyContent: "flex-start",
            columnGap: "32px",
            fontSize: "14px",
          }}
        >
          <CustomNextLink color="inherit" href={privacyRoute}>
            Privacy Policy
          </CustomNextLink>
          <CustomNextLink
            variant="body1"
            underline="none"
            color="inherit"
            href={tosRoute}
          >
            Terms of Service
          </CustomNextLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
